import React, { useState } from "react";
import { FaDownload } from "react-icons/fa";
// Data
import {
  educationData,
  jobExperienceData,
  trainerExperienceData,
  companiesData,
  courseraData,
  videoListData,
} from "../../data/data";
// Components
import Title from "../title/Title";
import Education from "./Education";
import Skills from "./Skills";
import Experience from "./Experience";
import Certificates from "./Certificates";
import Teaching from "./Teaching";
const Resume = () => {
  const [experience, setExperience] = useState(true);
  const [education, setEducation] = useState(false);
  const [skill, setSkill] = useState(false);
  const [certificates, setCertificates] = useState(false);
  const [teaching, setTeaching] = useState(false);
  return (
    <section id="resume" className="w-full py-16 border-b-black border-b-[1px]">
      {/* Title */}
      <Title
        title="5+ years of experience"
        desc="my resume"
        styles="text-center"
        fontSize="text-3xl md:text-5xl"
      />
      <div className="mb-14">
        <ul className="w-full grid md:grid-cols-2 lg:grid-cols-5">
          <li
            onClick={() =>
              setExperience(true) &
              setSkill(false) &
              setEducation(false) &
              setCertificates(false) &
              setTeaching(false)
            }
            className={`${
              experience
                ? "border-secondaryColor rounded-lg"
                : "border-transparent"
            } w-full h-20 bg-black bg-opacity-25 text-xl text-gray-300 flex justify-center cursor-pointer hover:bg-opacity-40 duration-300 items-center border-[1px]`}
          >
            Experience
          </li>
          <li
            onClick={() =>
              setExperience(false) &
              setSkill(true) &
              setEducation(false) &
              setCertificates(false) &
              setTeaching(false)
            }
            className={`${
              skill ? "border-secondaryColor rounded-lg" : "border-transparent"
            } w-full h-20 bg-black bg-opacity-25 text-xl text-gray-300 flex justify-center cursor-pointer hover:bg-opacity-40 duration-300 items-center border-[1px]`}
          >
            Professional Skills
          </li>
          <li
            onClick={() =>
              setExperience(false) &
              setSkill(false) &
              setEducation(false) &
              setCertificates(false) &
              setTeaching(true)
            }
            className={`${
              teaching
                ? "border-secondaryColor rounded-lg"
                : "border-transparent"
            } w-full h-20 bg-black bg-opacity-25 text-xl text-gray-300 flex justify-center cursor-pointer hover:bg-opacity-40 duration-300 items-center border-[1px]`}
          >
            Teaching
          </li>
          <li
            onClick={() =>
              setExperience(false) &
              setSkill(false) &
              setEducation(true) &
              setCertificates(false) &
              setTeaching(false)
            }
            className={`${
              education
                ? "border-secondaryColor rounded-lg"
                : "border-transparent"
            } w-full h-20 bg-black bg-opacity-25 text-xl text-gray-300 flex justify-center cursor-pointer hover:bg-opacity-40 duration-300 items-center border-[1px]`}
          >
            Education
          </li>
          <li
            onClick={() =>
              setExperience(false) &
              setSkill(false) &
              setEducation(false) &
              setCertificates(true) &
              setTeaching(false)
            }
            className={`${
              certificates
                ? "border-secondaryColor rounded-lg"
                : "border-transparent"
            } w-full h-20 bg-black bg-opacity-25 text-xl text-gray-300 flex justify-center cursor-pointer hover:bg-opacity-40 duration-300 items-center border-[1px]`}
          >
            Certificates
          </li>
        </ul>
      </div>
      <div>
        {education && (
          <Education
            trainerExperienceData={trainerExperienceData}
            educationData={educationData}
          />
        )}
        {skill && <Skills />}
        {experience && (
          <Experience
            trainerExperienceData={trainerExperienceData}
            jobExperienceData={jobExperienceData}
          />
        )}
        {certificates && (
          <Certificates
            courseraData={courseraData}
            companiesData={companiesData}
          />
        )}
        {teaching && <Teaching videoListData={videoListData} />}
      </div>
      {!certificates && (
      <div className="flex justify-between flex-col md:flex-row mt-8 gap-4">
      <a
        href="./resume1.pdf"
        download="resume1.pdf"
        className="btn w-full md:w-auto flex items-center justify-center"
      >
        <FaDownload className="mr-2" />
        resume (with picture)
      </a>
      <a
        href="./resume2.pdf"
        download="resume2.pdf"
        className="btn w-full md:w-auto flex items-center justify-center"
      >
        <FaDownload className="mr-2" />
        resume (without Picture)
      </a>
    </div>
    
      )}
    </section>
  );
};

export default Resume;
